import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import {
  COMPLETION_PERIOD,
  EXERCISE_PERIOD,
  FoundationPeriod,
  GstStatus,
  CI_LOAN_TENURE,
  OPTION_EXERCISE_FEE,
  OPTION_FEE,
  PurchaseTypes,
  CI_MORTGAGE_INTEREST_RATE,
  CI_LOAN_TO_VALUE,
  LEGAL_FEES,
} from '@/constants/commercial-industrial/purchase';

export const initialState = {
  formField: {
    purchaseType: PurchaseTypes.Resale,
    hasGST: GstStatus.YES,
    purchasePrice: '',
    valuationPrice: '',
    optionFee: OPTION_FEE.DEFAULT.toString(),
    optionExerciseFee: OPTION_EXERCISE_FEE.DEFAULT.toString(),
    legalFees: LEGAL_FEES.DEFAULT.toString(),
    loanTenure: CI_LOAN_TENURE.DEFAULT.toString(),
    mortgageInterestRate: CI_MORTGAGE_INTEREST_RATE.DEFAULT.toString(),
    loanToValue: CI_LOAN_TO_VALUE.DEFAULT.toString(),
    isCheckedMonthlyPayable: true,
    otpDate: new Date().toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT,
    completionPeriod: COMPLETION_PERIOD.DEFAULT,
    completionFoundationPeriod: FoundationPeriod.EIGHT_WEEKS,
  },
  loading: true,
};

export const commercialIndustrialPurchase = createSlice({
  name: 'ciPurchase',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = commercialIndustrialPurchase.actions;

export default commercialIndustrialPurchase.reducer;
